import { bindKeymapWithEditorCommand, keymap, toggleHighlightPalette } from '@atlaskit/editor-common/keymaps';
import { togglePalette } from '../editor-commands/palette';
export function keymapPlugin(_ref) {
  var api = _ref.api;
  var list = {};
  if (toggleHighlightPalette.common) {
    bindKeymapWithEditorCommand(toggleHighlightPalette.common, togglePalette(api), list);
  }
  return keymap(list);
}